const AppEnv = {
    TWICPICS_URL: __TWICPICS_URL__ || '',
    APP_ENV: __APP_ENV__ || 'local',
    isLocal() {
        return this.APP_ENV === 'local';
    },
    isProduction() {
        return this.APP_ENV === 'production';
    },
    getTwicPicsUrl() {
        return this.TWICPICS_URL;
    }
};

if (typeof window !== 'undefined') {
    window.AppEnv = AppEnv;
}

export default AppEnv;
